import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCommandManager } from '@view-model/models/framework/command';
import { toast } from 'react-hot-toast';

type Handler = () => void;
type Handlers = {
  handleUndo: Handler;
  handleRedo: Handler;
};

export const useUndoRedoHandlers = (): Handlers => {
  const { t } = useTranslation();
  const commandManager = useCommandManager();

  const handleUndo = useCallback(async () => {
    if (await commandManager.canUndo()) {
      commandManager.undo();
      toast(t('viewModel.undoRedo.undone'));
    } else {
      toast.error(t('viewModel.undoRedo.undoFailed'));
    }
  }, [commandManager, t]);

  const handleRedo = useCallback(async () => {
    if (await commandManager.canRedo()) {
      commandManager.redo();
      toast(t('viewModel.undoRedo.redone'));
    } else {
      toast.error(t('viewModel.undoRedo.redoFailed'));
    }
  }, [commandManager, t]);

  return { handleUndo, handleRedo };
};
